// extracted by mini-css-extract-plugin
export default {"productGrid":"Pia-z","centerLink":"Qia-z","productSection":"Ria-z","item":"Sia-z","ctaButton":"Tia-z"};